import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { makeStyles } from '@material-ui/core';
import { Checkbox, Grid, Tooltip } from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/hu';
import { useMutation } from 'react-query';
import { updateTodo } from '../../api/objective/todo.api';
import { addAlert } from '../../actions/alerts.action';
import { STATUS } from '../../utils/const';

const useStyles = makeStyles({
  root: {
    color: '#666666'
  },
  checkbox: {
    color: '#666666'
  },
  textBox: {
    margin: 'auto 0',
    display: 'flex',
    flexDirection: 'row'
  },
  deadline: {
    margin: 'auto 0 auto 10px'
  }
});

const TodoItem = ({ todo, objectiveId, onSubmitSuccess, status }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const updateTodoMutation = useMutation(
    async todo => {
      return await updateTodo({ objectiveId, todo });
    },
    {
      onSuccess: () => {
        onSubmitSuccess();
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const handleIsDoneChange = event => {
    updateTodoMutation.mutate({
      ...todo,
      is_done: event.target.checked
    });
  };

  return (
    <Grid container spacing={ 2 } key={ todo.id } className={ classes.root }>
      <Grid item xs={ 6 } className={ classes.textBox }>
        <Tooltip
          disableHoverListener={ STATUS.ACTIVE === status }
          title={ t(`objective.todos.error.statusError`) }>
          <span>
            <Checkbox
              className={ classes.checkbox }
              checked={ todo.is_done }
              onChange={ handleIsDoneChange }
              disabled={ STATUS.ACTIVE !== status }
            />
          </span>
        </Tooltip>
        <p className={ classes.textBox }> {todo.name}</p>
      </Grid>
      {todo.deadline &&
        <Grid item xs={ 6 } className={ classes.textBox }>
          <DateRangeIcon />
          <div className={ classes.deadline }>
            {moment(todo.deadline).format('L')}
          </div>
        </Grid>
      }
    </Grid>
  );
};

export default TodoItem;
